'use client';

import { useLocale } from 'next-intl';
import { DirectionProvider } from '@radix-ui/react-direction';
import { useRtlSync } from '@/shared/hooks/use-rtl-sync';
import { isRtlLocale } from '@/shared/constants/locales';

/**
 * Provider that syncs RTL direction with locale changes
 * Must be rendered inside NextIntlClientProvider.
 *
 * Wraps children in Radix `DirectionProvider` so Radix primitives (Tabs,
 * Dialog, …) inherit the same direction as the html `dir` attribute. Without
 * it Radix Tabs defaults to `dir="ltr"` on its Root, which would force the
 * Design/Album segmented tabs to render LTR inside an otherwise RTL document.
 */
export function RtlSyncProvider({ children }: { children: React.ReactNode }) {
  useRtlSync();
  const locale = useLocale();
  const dir = isRtlLocale(locale) ? 'rtl' : 'ltr';
  return <DirectionProvider dir={dir}>{children}</DirectionProvider>;
}
